import {buildRefinedSlpUrl} from '../../../utils/urls';
import {orderedFiltersBySEOhits} from '../../../utils/orderedFiltersBySEOhints';

export const getRefinementKey = (link) => {
    if (link?.url) {
        const filter = orderedFiltersBySEOhits.find((orderedFilter) =>
            link.url.includes(orderedFilter)
        );

        return filter ? filter.replace('filter:', '') : null;
    }
    return null;
};

export const replaceSerpUrls = ({
    category,
    site: siteName,
    basePath,
    domain,
    seoPath,
    isRefined,
}) => {
    if (category?.links) {
        category.links.forEach((link) => {
            if (link.url.includes('search')) {
                const site = {
                    name: siteName,
                    basePath,
                    domain,
                };
                const key = getRefinementKey(link);
                const refinedSlpUrl = buildRefinedSlpUrl({
                    seoPath,
                    site,
                    isRefined,
                    key,
                });
                link.url = refinedSlpUrl || link.url;
            }
        });
    }

    return category;
};
